import SsrAutoComplete from './SsrAutoComplete'

export default SsrAutoComplete
